export default __webpack_public_path__ + "static/media/ic-icon-date.9daa43cc.png";